import { semantic } from '@arcade/web'
import * as tokens from '@cash-design-system/tokens'

import { ArcadeThemeColorsOverride } from './arcadeColors'
import { ThemeColorsOverride } from './colors'
import { monochromeArcadeColors } from './monochromeColors'

// Default light inactive chrome is #959595, which is just under 3:1 on white (~2.995:1). We hardcode
// #949494 so non-text UI meets a 3:1 contrast ratio against white.
const localLightInactiveNeutral = '#949494'

export const localArcadeColors: Partial<ArcadeThemeColorsOverride> = {
  ...monochromeArcadeColors,
  checkboxInactiveBorderDefault: {
    light: localLightInactiveNeutral,
    dark: tokens.ColorPaletteCobalt40,
  },
  radioInactiveBorderDefault: {
    light: localLightInactiveNeutral,
    dark: tokens.ColorPaletteCobalt40,
  },
  toggleActiveBackgroundDefault: {
    light: tokens.ColorPaletteBlack,
    dark: tokens.ColorPaletteWhite,
  },
  toggleInactiveBackgroundDefault: {
    light: localLightInactiveNeutral,
    dark: tokens.ColorPaletteGray75,
  },
  toggleActiveBackgroundDisabled: {
    light: tokens.ColorPaletteBlack,
    dark: tokens.ColorPaletteWhite,
  },
  toggleKnobBackgroundDefault: {
    light: tokens.ColorPaletteWhite,
    dark: tokens.ColorPaletteBlack,
  },
}

export const localMooncakeColors = {
  progressBarFill: {
    light: semantic.iconSuccess.light,
    dark: semantic.iconSuccess.dark,
  },
} as ThemeColorsOverride
